<!-- 我的优惠券 -->
<template>
  <div class="my-coupon">

<!--    <van-tabs-->
<!--      v-model="active"-->
<!--      swipeable-->
<!--      animated-->
<!--      sticky-->
<!--      color="#E3C194"-->
<!--      line-width="80px"-->
<!--      line-height="2px"-->
<!--      title-inactive-color="#BEBEBE"-->
<!--      title-active-color="#171717">-->

<!--      <van-tab title="有效券">-->

        <!-- <van-empty image="search" description="暂无相关内容" /> -->
<!--        <div class="search-box flex justify-content-between align-items-center">-->
<!--          <input type="text" placeholder="请输入兑换码" class="search-input" />-->
<!--          <input type="button" value="兑换" class="btn" />-->
<!--        </div>-->

        <div v-show="list.length === 0" style="text-align: center">
          <van-empty image="search" description="暂无相关内容" />
          <p style="text-decoration:underline;color:rgb(212 114 32)" @click="receive">领取免息券</p>
        </div>

        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <div class="pad-side20">
              <div
                class="list-item flex align-items-center"
                v-for="(item, index) in list"
                :key="index">
                <div class="left">
                  <p class="money">{{setTicketName(item)}}</p>
                </div>
                <div class="right">
                  <div class="name">{{item.ticketName}}</div>
                  <p class="date">有效期：{{item.vaildTimeStatus}} - {{item.vaildTimeEnd}}</p>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
<!--      </van-tab>-->

<!--      <van-tab title="已过期">-->
<!--        &lt;!&ndash; <van-empty image="search" description="暂无相关内容" /> &ndash;&gt;-->
<!--        <div class="search-box flex justify-content-between align-items-center">-->
<!--          <input type="text" placeholder="请输入兑换码" class="search-input" />-->
<!--          <input type="button" value="兑换" class="btn" />-->
<!--        </div>-->
<!--        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">-->
<!--          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">-->
<!--            <div class="pad-side20">-->
<!--              <div class="list-item flex align-items-center">-->
<!--                <div class="left">-->
<!--                  <p class="money">30元</p>-->
<!--                  <p class="font12">满10元可用</p>-->
<!--                </div>-->
<!--                <div class="right">-->
<!--                  <div class="name">平台券</div>-->
<!--                  <p class="date">有效期：2017.03.10 - 2017.12.30</p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </van-list>-->
<!--        </van-pull-refresh>-->
<!--      </van-tab>-->

<!--    </van-tabs>-->
  </div>
</template>

<script>
import { Tab, Tabs, Empty, List, PullRefresh } from "vant";
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  name: "MyCoupon",

  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [Empty.name]: Empty,
    [PullRefresh.name]: PullRefresh
  },

  data() {
    return {
      active: 0,
      list: [],
      loading: false,
      finished: false,
      isLoading: false
    };
  },

  computed: {
    ...mapState(["userInfo"]),
  },

  created() {},

  methods: {

    onRefresh() {
      this.$toast("刷新成功");
      this.isLoading = false;
    },

    onLoad() {
      let params = {
        idNo: this.userInfo.idNo,
        phoneNo: this.userInfo.phoneNo,
        userId: this.userInfo.userID,
      }
      axios({
        method: 'post',
        url: process.env.VUE_APP_URL + "/GetFreeTicketList",
        headers: {
          'token': localStorage.getItem('token')
        },
        data: params
      }).then(res => {
        if (res.data.resCode === '0000') {
          if (typeof(res.data.freeTicket) == "undefined") {
            //加载状态结束
            this.loading = false;
            this.finished = true;
            this.isLoading = false;
            return;
          }
          for (let i = 0; i < Object.keys(res.data.freeTicket).length; i++) {
            this.list.push(res.data.freeTicket[i]);
          }
          //加载状态结束
          this.loading = false;
          this.finished = true;
        } else {
          this.$dialog.alert({
            title: "提示",
            message: res.data.resMessage,
            showCancelButton: true
          });
        }
      })
    },

    setTicketName(item) {
      if (item.ticketType === "1") {
        return "¥" + item.ticketMoney;
      } else if (item.ticketType === "3") {
        if (item.reduction === "1") {
          return '大神卷';
        } else {
          return item.reductionNum + "期";
        }
      } else {
        return item.ticketDays + "天";
      }
    },

    receive() {
      let baseUrl = process.env.VUE_APP_URL.split("JmxApi")[0];
      if (baseUrl.indexOf("test") !== -1) {
        location.href = 'https://test.jmscfc.com:28087/Qrcode/#/getTicket?data=LFuNSdC/Ah98rVLsWPWt6Chp8l7uodrlus84xnVZF4EPffZbu9jJ2/Sjo3RHsxGdL-GMdEU8hWJgRrQpKsNP5Q==&from=7000203ICJR1F012';
      } else {
        location.href = 'https://qrcode.jmscf.com.cn/Qrcode/#/getTicket?data=LFuNSdC/Ah98rVLsWPWt6Chp8l7uodrlus84xnVZF4EPffZbu9jJ2/Sjo3RHsxGdL-GMdEU8hWJgRrQpKsNP5Q==&from=7000203ICJR1F012';
      }
    }

  }
};
</script>

<style lang='less' scoped>
.my-coupon {
  background-color: #f7f7f7;
  min-height: 100vh;
}
.search-box {
  background: rgba(255, 255, 255, 1);
  padding: 20px;
  line-height: 32px;
  input {
    border-radius: 22px;
  }
  .search-input {
    width: 200px;
    background: rgba(246, 246, 246, 1);
    padding: 0 20px;
  }
  .btn {
    width: 85px;
    background: rgba(233, 58, 50, 1);
    color: #fff;
  }
}
.list-item {
  height: 106px;
  padding: 0 14px;
  box-sizing: border-box;
  background: url("../../assets/imgs/other/coupon-bj.png") no-repeat;
  background-size: auto 106px;
  position: relative;
  margin-top: 20px;
  border-radius: 6px;
  overflow: hidden;
  .left {
    color: #fff;
    .money {
      color: #edd4af;
      font-size: 20px;
      font-weight: bold;
      width: 50px;
      margin-right: 43px;
    }
  }
  .right {
    .name {
      font-size: 17px;
      font-weight: 500;
      padding-bottom: 5px;
    }
    .date {
      font-size: 12px;
    }
  }
}
</style>